/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';

export const Spacer = forwardRef<HTMLDivElement, { itemKey: string }>(({ itemKey }, ref) => <div style={{ marginRight: 'auto' }} key={itemKey} ref={ref} />);
